import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-family-relationship.reducer';
import { IMetFamilyRelationship } from 'app/shared/model/met-family-relationship.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetFamilyRelationship = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metFamilyRelationshipList = useAppSelector(state => state.metFamilyRelationship.entities);
  const loading = useAppSelector(state => state.metFamilyRelationship.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-family-relationship-heading" data-cy="MetFamilyRelationshipHeading">
        <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.home.title">Met Family Relationships</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.home.createLabel">
              Create new Met Family Relationship
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metFamilyRelationshipList && metFamilyRelationshipList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metFamilyRelationshipList.map((metFamilyRelationship, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metFamilyRelationship.id}`} color="link" size="sm">
                      {metFamilyRelationship.id}
                    </Button>
                  </td>
                  <td>{metFamilyRelationship.code}</td>
                  <td>{metFamilyRelationship.name}</td>
                  <td>{metFamilyRelationship.nameAr}</td>
                  <td>{metFamilyRelationship.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metFamilyRelationship.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${metFamilyRelationship.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metFamilyRelationship.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metFamilyRelationship.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.home.notFound">
                No Met Family Relationships found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetFamilyRelationship;
